import React from 'react';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {
    faBook,
    faCode,
    faCoins,
    faMoneyBill,
    faLock
} from "@fortawesome/free-solid-svg-icons";
import {Link} from 'react-router-dom';


const SectionItemBar = ({
                            title,
                            to,
                            xp,
                            credit,
                            hasBBorder = true,
                            typ = 0,
                            enabled = true
                        }) => {

    const content = (
        <div
            className={`
        flex
        items-center
        justify-between
        gap-x-3
        px-10
        py-8
        ${hasBBorder ? 'border-b-4' : 'border-0'}
        border-gray-200

        ${
                enabled
                    ? 'hover:bg-gray-200 cursor-pointer transition'
                    : 'bg-gray-300 opacity-50 cursor-not-allowed'}`}>

            <div className="flex gap-x-5">

                <div
                    className={`
                        w-12
                        h-12
                        text-white
                        text-xl
                        font-bold
                        rounded-full
                        flex
                        items-center
                        justify-center
                        ${enabled
                        ? 'bg-gray-700'
                        : 'bg-gray-400'
                    }
                    `}
                >

                    {enabled ? (

                        typ === 0
                            ? <FontAwesomeIcon icon={faBook} size="lg"/>
                            : <FontAwesomeIcon icon={faCode} size="lg"/>

                    ) : (

                        <FontAwesomeIcon
                            icon={faLock}
                            size="lg"
                        />

                    )}

                </div>


                <div>

                    <span className="text-md mb-2 text-gray-600">
                        {typ === 0 ? 'درس' : 'پروژه'}
                    </span>

                    <h3 className="font-bold text-xl">
                        {title}
                    </h3>

                </div>

            </div>


            <div className="hidden md:flex items-center text-lg font-bold mr-auto">

                <div className="flex items-center gap-x-3 ml-5">

                    <span>
                        {credit ?? 0}
                    </span>

                    <FontAwesomeIcon
                        icon={faCoins}
                        size="lg"
                    />

                </div>


                <div className="flex items-center gap-x-3">

                    <span>
                        {xp ?? 0}
                    </span>

                    <FontAwesomeIcon
                        icon={faMoneyBill}
                        size="lg"
                    />

                </div>

            </div>

        </div>
    );


    if (!enabled) {
        return (
            <div>
                {content}
            </div>
        );
    }


    return (
        <Link to={to}>
            {content}
        </Link>
    );
};


export default SectionItemBar;